// React component that returns a grid of two grids. In the first gird the image is drawn and a list of bonsai pots. In the second grid are tools to manipulate the image
import React from "react";

import { BrowserRouter as Router } from "react-router-dom";
import ScreenRoot from "./screens/Root";
import { pallete } from "./libs/pallete";
import { Box } from "@mui/material";
// function that takes the p5 canvas and writes it to png

const GardeningApp = () => {
  return (
    <div display="flex">
      <Router basename="/">
        <Box
          sx={{
          }}
        >
          <ScreenRoot />{" "}
        </Box>
      </Router>
    </div>
  );
};

export default GardeningApp;
